import { aiPlanningPlanEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningPlanEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { softwarePlannerPlanRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwarePlannerPlanRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningSoftwarePlanPageEntrypoint = createChromelessEntryPoint({
	main: aiPlanningPlanEntrypoint,
});

export const softwarePlannerPlanRouteEntry: Route = createEntry(softwarePlannerPlanRoute, () => ({
	group: 'software',
	ufoName: 'software-planner-plan',
	layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
	resources: [],

	meta: {
		reporting: {
			id: 'software-planner-plan',
			packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
			teamName: 'Dev AI - Planner',
		},
	},

	entryPoint: () =>
		fg('jira_ai_planner_tab') ? aiPlanningSoftwarePlanPageEntrypoint : notFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
